import {
  ToggleField,
  MultiEmailField,
} from '../models';

/** The first 2 fields are a special case with special treatment */
const Emails = [
  new MultiEmailField({
    kWord: 'emailsSuper',
    label: 'E-mail dos proprietários*',
    required: true,
    min: 1,
    maxFunc: (state) => (state?.supers?.value ?? 1),
  }),
  new MultiEmailField({
    kWord: 'emailsScientist',
    label: 'E-mail dos cientistas',
    min: 0,
    maxFunc: (state) => (state?.scientists?.value ?? 1),
  }),
  new ToggleField({
    kWord: 'sendmail',
    label: 'Enviar e-mail aos usuários',
  }),
];

export default Emails;
